import React from 'react';
import styles from './Tag.module.scss'
import {TagPropsInterface} from "./Tag.props.interface";

const Tag: React.FC<TagPropsInterface> = (
    {
        type = 'secondary',
        size = 'medium',
        children,
        ...rest
    }) => {

    return (
        <span className={[
            styles.container,
            type ? styles[type] : 'secondary',
            size ? styles[size] : 'medium'
        ].filter(x => x ?? x).join(' ')}
              {...rest}>
            {children}
        </span>
    )
};

export default Tag;
